<template>
    <div>
        <el-dialog
            title="复制员工"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="500px">
            <le-company-under-select label='来源商户' v-model="form.companyId" ></le-company-under-select>
            <le-company-under-select label='目标商户' v-model="form.targetCompanyId" ></le-company-under-select>
            <div slot="footer">
                <el-button type="primary" plain @click="dialogVisible = false">关闭</el-button>
                <el-button type="primary"  @click="submit">提交</el-button>
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dialogVisible: false,
                form: {
                    companyId: '',
                    targetCompanyId: ''
                }
            };
        },
        methods:{
            submit () {
                if(!this.form.companyId) {
                    this.$message.error('请选择来源商户')
                    return
                }
                if(!this.form.targetCompanyId) {
                    this.$message.error('请选择目标商户')
                    return
                }
                this.$confirm('是否确认提交？', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(_=>{
                    this.$Axios._post({
                        url: this.$Config.apiUrl.copyCompanyRbacUserAndMenu,
                        method: "post",
                        params: {
                            "baseCompanyId": this.form.companyId,
                            "targetCompanyId": this.form.targetCompanyId,
                        },
                    })
                    .then(res=>{
                        if (res.result.code == 0) {
                            this.$message.success('操作成功')
                            this.dialogVisible = false
                        } else {
                            this.$message.error(res.result.message)
                        }
                    })
                    .catch(err=>{

                    })
                }).catch(err=>{ console.log(err); })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tableTitle{
        font-size: 14px;
        color: #333333;
        font-weight: 700;
        margin: 24px 0;
        display: block;
    }
    /deep/ .el-dialog__wrapper{
        display: flex;
        justify-content: center !important;
        align-items: center !important;
    }
    /deep/ .el-dialog__body{
        padding: 10px 20px !important;
    }
    /deep/ .el-dialog{
        margin: 0 auto !important;
    }
    /deep/ .is-disabled{
        color: #333333 !important;
    }
    /deep/ .el-dialog__header{
        border-bottom: 1px solid #EBEEF5;
    }
    .formContent{
        max-height: 70vh;
        overflow: auto;
    }
</style>